import { Platform } from 'react-native';
import * as Haptics from 'expo-haptics';

/**
 * Spec háptico del producto (programa UX, epic #1362).
 *
 * - `hapticTap` — selección liviana: tiles, chips, toggles, agregar al carrito.
 * - `hapticConfirm` — avance/confirmación: siguiente paso, guardar.
 * - `hapticSuccess` — resultado exitoso: venta cobrada, org creada, primera venta.
 * - `hapticWarning` — atención: validación con corrección posible.
 * - `hapticError` — error que bloquea la acción.
 *
 * Web no hace nada (sin API de vibración en el modelo de uso escritorio).
 */
const enabled = Platform.OS !== 'web';

export function hapticTap(): void {
  if (enabled) void Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
}

export function hapticConfirm(): void {
  if (enabled) void Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Medium);
}

export function hapticSuccess(): void {
  if (enabled) void Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success);
}

export function hapticWarning(): void {
  if (enabled) void Haptics.notificationAsync(Haptics.NotificationFeedbackType.Warning);
}

export function hapticError(): void {
  if (enabled) void Haptics.notificationAsync(Haptics.NotificationFeedbackType.Error);
}
